export enum VideoProvider {
    Twilio = 'twilio',
    Zoom = 'zoom',
}
